import CalculationResults from './CalculationResults';

export default CalculationResults;
